import React from "react";

export default function PageLoader() {
  return (
    <div role="status" aria-live="polite" className="page-loader-container">
      <div className="page-loader-spinner" />
      <span className="page-loader-text">Đang tải trang...</span>
    </div>
  );
}
